module.exports = [
	"yabbered",
	"yabbering",
	"yabbers",
	"yabbie",
	"yabbies",
	"yabby",
	"yacca",
	"yaccas",
	"yacht",
	"yachted",
	"yachter",
	"yachters",
	"yachtie",
	"yachties",
	"yachting",
	"yachtings",
	"yachts",
	"yachtsman",
	"yachtsmen",
	"yack",
	"yacked",
	"yacker",
	"yacking",
	"yacks",
	"yaff",
	"yaffed",
	"yaffing",
	"yaffingale",
	"yaffle",
	"yaffles",
	"yaffs",
	"yager",
	"yagers",
	"yagger",
	"yaggers",
	"yah",
	"yahoo",
	"yahoos",
	"yahs",
	"yak",
	"yakimona",
	"yakimonas",
	"yakitori",
	"yakitoris",
	"yakka",
	"yakked",
	"yakker",
	"yakking",
	"yakow",
	"yakows",
	"yaks",
	"yakuza",
	"yald",
	"yale",
	"yales",
	"yam",
	"yamen",
	"yamens",
	"yammer",
	"yammered",
	"yammering",
	"yammerings",
	"yammers",
	"yams",
	"yamulka",
	"yamulkas",
	"yang",
	"yangs",
	"yank",
	"yanked",
	"yanking",
	"yanks",
	"yanqui",
	"yanquis",
	"yaourt",
	"yaourts",
	"yap",
	"yapock",
	"yapocks",
	"yapok",
	"yapoks",
	"yapon",
	"yapons",
	"yapp",
	"yapped",
	"yapper",
	"yappers",
	"yappie",
	"yappies",
	"yapping",
	"yapps",
	"yappy",
	"yaps",
	"yapster",
	"yapsters",
	"yard",
	"yardage",
	"yardages",
	"yardang",
	"yardangs",
	"yardarm",
	"yardarms",
	"yardbird",
	"yardbirds",
	"yarded",
	"yarding",
	"yardland",
	"yardlands",
	"yardman",
	"yardmaster",
	"yardmen",
	"yards",
	"yardstick",
	"yardsticks",
	"yardwand",
	"yardwands",
	"yare",
	"yarely",
	"yarer",
	"yarest",
	"yarmulka",
	"yarmulkas",
	"yarmulke",
	"yarmulkes",
	"yarn",
	"yarned",
	"yarning",
	"yarns",
	"yarpha",
	"yarphas",
	"yarr",
	"yarraman",
	"yarramans",
	"yarramen",
	"yarran",
	"yarrans",
	"yarrow",
	"yarrows",
	"yarrs",
	"yashmak",
	"yashmaks",
	"yatagan",
	"yatagans",
	"yataghan",
	"yataghans",
	"yate",
	"yatter",
	"yattered",
	"yattering",
	"yatterings",
	"yatters",
	"yaud",
	"yauds",
	"yauld",
	"yaup",
	"yauper",
	"yaupon",
	"yaupons",
	"yaw",
	"yawed",
	"yawing",
	"yawl",
	"yawled",
	"yawling",
	"yawls",
	"yawn",
	"yawned",
	"yawning",
	"yawningly",
	"yawnings",
	"yawns",
	"yawny",
	"yawp",
	"yawped",
	"yawper",
	"yawpers",
	"yawping",
	"yawps",
	"yaws",
	"yawy",
	"yblent",
	"ybrent",
	"yclad",
	"ycleped",
	"yclept",
	"ydrad",
	"ydred",
	"ye",
	"yea",
	"yeah",
	"yeahs",
	"yealm",
	"yealmed",
	"yealming",
	"yealms",
	"yean",
	"yeaned",
	"yeaning",
	"yeanling",
	"yeanlings",
	"yeans",
	"year",
	"yeard",
	"yearded",
	"yearding",
	"yeards",
	"yearlies",
	"yearling",
	"yearlings",
	"yearlong",
	"yearly",
	"yearn",
	"yearned",
	"yearner",
	"yearners",
	"yearning",
	"yearningly",
	"yearnings",
	"yearns",
	"years",
	"yeas",
	"yeast",
	"yeasted",
	"yeastier",
	"yeastiest",
	"yeastiness",
	"yeasting",
	"yeastlike",
	"yeasts",
	"yeasty",
	"yech",
	"yede",
	"yegg",
	"yeggman",
	"yeggmen",
	"yeld",
	"yeldrock",
	"yeldrocks",
	"yelk",
	"yelks",
	"yell",
	"yelled",
	"yelling",
	"yellings",
	"yelloch",
	"yelloched",
	"yelloching",
	"yellochs",
	"yellow",
	"yellowback",
	"yellowcake",
	"yellowed",
	"yellower",
	"yellowest",
	"yellowhead",
	"yellowing",
	"yellowish",
	"yellowness",
	"yellows",
	"yellowy",
	"yells",
	"yelm",
	"yelmed",
	"yelming",
	"yelms",
	"yelp",
	"yelped",
	"yelper",
	"yelpers",
	"yelping",
	"yelpings",
	"yelps",
	"yelt",
	"yelts",
	"yen",
	"yenned",
	"yenning",
	"yens",
	"yenta",
	"yentas",
	"yeoman",
	"yeomanly",
	"yeomanry",
	"yeomen",
	"yep",
	"yeps",
	"yerba",
	"yerbas",
	"yerd",
	"yerded",
	"yerding",
	"yerds",
	"yerk",
	"yerked",
	"yerking",
	"yerks",
	"yes",
	"yeses",
	"yeshiva",
	"yeshivah",
	"yeshivahs",
	"yeshivas",
	"yeshivot",
	"yeshivoth",
	"yesses",
	"yest",
	"yester",
	"yesterday",
	"yesterdays",
	"yestereve",
	"yestereven",
	"yestereves",
	"yestermorn",
	"yestern",
	"yesteryear",
	"yestreen",
	"yesty",
	"yet",
	"yeti",
	"yetis",
	"yett",
	"yetts",
	"yeuk",
	"yeuked",
	"yeuking",
	"yeuks",
	"yeven",
	"yew",
	"yews",
	"yex",
	"yexed",
	"yexes",
	"yexing",
	"yfere",
	"ygo",
	"ygoe",
	"yiddishism",
	"yield",
	"yieldable",
	"yielded",
	"yielder",
	"yielders",
	"yielding",
	"yieldingly",
	"yieldings",
	"yields",
	"yike",
	"yikes",
	"yikker",
	"yikkered",
	"yikkering",
	"yikkers",
	"yill",
	"yills",
	"yin",
	"yince",
	"yins",
	"yip",
	"yipped",
	"yippee",
	"yippees",
	"yipper",
	"yippers",
	"yippies",
	"yipping",
	"yips",
	"yird",
	"yirded",
	"yirding",
	"yirds",
	"yirk",
	"yirked",
	"yirking",
	"yirks",
	"yite",
	"yites",
	"ylem",
	"ylke",
	"ylkes",
	"ynambu",
	"ynambus",
	"yo",
	"yob",
	"yobbery",
	"yobbish",
	"yobbishly",
	"yobbism",
	"yobbo",
	"yobboes",
	"yobbos",
	"yobs",
	"yock",
	"yocked",
	"yocking",
	"yocks",
	"yod",
	"yode",
	"yodel",
	"yodeled",
	"yodeler",
	"yodelers",
	"yodeling",
	"yodelled",
	"yodeller",
	"yodellers",
	"yodelling",
	"yodels",
	"yodle",
	"yodled",
	"yodler",
	"yodlers",
	"yodles",
	"yodling",
	"yoga",
	"yogh",
	"yoghourt",
	"yoghourts",
	"yoghurt",
	"yoghurts",
	"yogi",
	"yogic",
	"yogin",
	"yogini",
	"yoginis",
	"yogins",
	"yogis",
	"yogism",
	"yogurt",
	"yogurts",
	"yohimbine",
	"yoick",
	"yoicked",
	"yoicking",
	"yoicks",
	"yoicksed",
	"yoickses",
	"yoicksing",
	"yojan",
	"yojana",
	"yojanas",
	"yojans",
	"yok",
	"yoke",
	"yoked",
	"yokel",
	"yokelish",
	"yokels",
	"yokes",
	"yoking",
	"yokings",
	"yokozuna",
	"yokozunas",
	"yoks",
	"yoldring",
	"yoldrings",
	"yolk",
	"yolked",
	"yolkier",
	"yolkiest",
	"yolks",
	"yolky",
	"yomp",
	"yomped",
	"yomping",
	"yomps",
	"yon",
	"yond",
	"yonder",
	"yoni",
	"yonis",
	"yonker",
	"yonkers",
	"yonks",
	"yont",
	"yoof",
	"yoop",
	"yoops",
	"yopper",
	"yoppers",
	"yore",
	"yores",
	"york",
	"yorked",
	"yorker",
	"yorkers",
	"yorkie",
	"yorkies",
	"yorking",
	"yorks",
	"yos",
	"you",
	"youk",
	"youked",
	"youking",
	"youks",
	"young",
	"youngberry",
	"younger",
	"youngest",
	"youngish",
	"youngling",
	"younglings",
	"youngly",
	"youngness",
	"youngster",
	"youngsters",
	"younker",
	"younkers",
	"your",
	"yourn",
	"yours",
	"yourself",
	"yourselves",
	"yourt",
	"yourts",
	"youth",
	"youthful",
	"youthfully",
	"youthhead",
	"youthhood",
	"youthly",
	"youths",
	"youthsome",
	"youthy",
	"yow",
	"yowe",
	"yowes",
	"yowie",
	"yowies",
	"yowl",
	"yowled",
	"yowley",
	"yowleys",
	"yowling",
	"yowlings",
	"yowls",
	"yows",
	"ypight",
	"ypsiliform",
	"ypsiloid",
	"yrapt",
	"yrent",
	"yrivd",
	"ytterbia",
	"ytterbium",
	"yttria",
	"yttric",
	"yttrious",
	"yttrium",
	"yuan",
	"yuca",
	"yucas",
	"yucca",
	"yuccas",
	"yuck",
	"yucked",
	"yucker",
	"yuckers",
	"yuckier",
	"yuckiest",
	"yucking",
	"yucks",
	"yucky",
	"yuft",
	"yug",
	"yuga",
	"yugas",
	"yugs",
	"yuk",
	"yukata",
	"yukatas",
	"yuke",
	"yuked",
	"yukes",
	"yuking",
	"yukkier",
	"yukkiest",
	"yukky",
	"yuko",
	"yukos",
	"yuks",
	"yulan",
	"yulans",
	"yule",
	"yules",
	"yuletide",
	"yuletides",
	"yummier",
	"yummiest",
	"yummy",
	"yup",
	"yupon",
	"yupons",
	"yuppie",
	"yuppiedom",
	"yuppies",
	"yuppified",
	"yuppifies",
	"yuppify",
	"yuppifying",
	"yuppy",
	"yups",
	"yurt",
	"yurts",
	"yus",
	"ywis"
];


//////////////////
// WEBPACK FOOTER
// ./src/data/words-y.json
// module id = 976
// module chunks = 1